import React, { useEffect, useState } from "react";
import "./style.scss";
import { useHistory } from "react-router-dom";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import twoGears from "../../../../../assets/svg/twoGears.svg";
import threeGears from "../../../../../assets/svg/threeGears.svg";
import graphImage from "../../../../../assets/svg/graphImage.svg";
import startupBtn from "../../../../../assets/svg/blueBtnFilter.svg";
import fiveLine from "../../../../../assets/svg/fiveLines.svg";
import startupIcon from "../../../../../assets/svg/dashboard/startup_application.svg";
import cohortIcon from "../../../../../assets/svg/dashboard/cohort_application.svg";
import userGuide from "../../../../../assets/pdf/MAARGStartupUserGuide-April 23.pdf";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {
  getPredefineOptionsList,
  getCountersList,
  getCountersSessions,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { getMentorCohortApplicationList } from "../../MentorDashboard/dependencies/action";
import { getNewMessagesDash } from "../dependencies/action";
import * as moment from "moment";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import HorizontalBarChart from "../../Chart";
import {
  MENTOR_SEARCH_REQUEST_LIST,
  STARTUP_APPLICATION,
  SEARCH_LIST_COUNTERS,
  VIEW_COUNTER_SESSIONS,
  VIEW_COUNTER_HOURS,
  MY_MENTORSHIP_LIST,
  MENTORSHIPS_COUNTER,
} from "../../../../common/constants/ApplicationUrl";
import axios from "axios";
import { VIEW_STARTUP_APPLICATION_DATA } from "../../../../common/constants/ApplicationUrl";

import UploadProgressReportModal from "../../../../common/uploadProgressReportModal";
import api from "../../../../common/dependencies/utils/Api";
import ModalFilters from "../../../../common/modalFilters";
import Chart from "react-apexcharts";
import ModalHOC from "../../../../common/Modal";
import CustomizedDialogs from "./Modal";
import swal from "sweetalert";
import { PRODUCTION_MOVE_HIDDEN } from "../../../../common/constants/actionConstants";
import { types } from "../../../../common/dependencies/reducer/comingSoonReducer";
import Modal from "./Modal/modal";
import { getCohortStartupList } from "../dependencies/action";
const StartupDashboard = (props) => {
  const html = document.getElementsByTagName("html")[0];

  const { getNewMessagesDash, getNewMessagesData, getCohortStartupList } =
    props;
  const history = useHistory();
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));

  const [indexCounter, setIndexCounter] = useState(0);
  const [saveAsDraftStatus, setSaveAsDraftStatus] = useState();
  const [draftResponse, setDraftResponse] = useState("");
  const [counters, setCounters] = useState();
  const [session, setSession] = useState();
  const [hours, setHours] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [cohortRedirection, setCohortRedirection] = useState("");
  //change this to true to show, and false to hide
  const [modalOpen2, setModalOpen2] = useState(true);
  const [reportData, setReportData] = useState("");
  const loggedIn = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const [engagementList, setEngagementList] = useState([]);
  const [counterData, setCounterData] = useState();
  const [mentorCounter, setMentorCounter] = useState(false);

  const progressReport = JSON.parse(localStorage.getItem("ProgressReport"));
  useEffect(() => {
    html.style.overflow = "auto";

    setTimeout(() => {
      localStorage.removeItem("myRequests");
      localStorage.removeItem("startupAllMentorList");
      localStorage.removeItem("mentorStartupRequest");
      localStorage.removeItem("startUpRequests");
      localStorage.removeItem("CohortStartupRequest");
      localStorage.removeItem("cohortMentorshipsStartup");
    }, 1000);

    // if (reportData !== "") {
    // }
  }, [reportData]);
  const ViewApplication = (item) => {
    let reRoute = window.open(`/view-StartupApplication/${item}`, "_blank");
    reRoute.id = item;
    // history.push({
    //   pathname: "/view-StartupApplication",
    //   state: dpiitNo,
    // });
  };
  const redirectProfile = (dpiitNo) => {
    let reRoute = window.open(`/startup-profile/${dpiitNo}`, "_blank");
    reRoute.id = dpiitNo;
    // history.push({
    //   pathname: "/startup-profile",
    //   state: dpiitNo,
    //   // state: { data: props.history.location.state, prevPage: "startUpDash" },
    // });
  };
  const EditApplication = (applicationStatus) => {
    history.push({
      pathname: "/startup-form",
      state: history.location.state,
      fromModule:
        applicationStatus === "DRAFT" ? "completeApplication" : "editProfile",
    });
  };
  useEffect(() => {
    let params = {
      id: JSON.parse(localStorage.getItem("SavedLoggedInData")).id, //  id of logged in user
    };
    getNewMessagesDash(params);
  }, []);
  const handleShow = () => {
    setIsModalShown(true);
  };

  const isValidNewOption = (inputValue, selectValue) =>
    inputValue.length > 0 && selectValue.length < 11;
  const {
    registerMentor,
    getPredefineOptionsList,
    getPredefineOptions,
    getCountersList,
    getCountersSessions,
    getCounter,
    getSession,
    getMentorCohortApplicationList,
    getCohortTableData,
    getListData,
  } = props;

  // const [session, setSession] = useState(getSession);
  useEffect(() => {
    getPredefineOptionsList();
  }, []);
  useEffect(() => {
    modifyGraphData();
  }, [counters]);

  const ViewMentorApplicaiton = (
    DashboardMentorHomeList,
    applicationId,
    applicationStatus,
    applicationView
  ) => {
    if (
      applicationStatus === "REQUESTINFO" ||
      applicationStatus === "VERIFIED"
    ) {
      if (applicationView === "ApplicationView") {
        history.push({
          pathname: "/view-application",
          state: {
            id: applicationId,
            applicationStatus: applicationStatus,
            action: "ViewMyApplication",
            fromModule: "mentorDashboardHome",
          },
        });
      } else {
        history.push({
          pathname: "/become-a-mentor",
          state: DashboardMentorHomeList && DashboardMentorHomeList,
          action: "EditApplication",
          fromModule: "mentorDashboardHome",
        });
      }
    } else {
      history.push({
        pathname: "/view-application",
        state: {
          id: applicationId,
          applicationStatus: applicationStatus,
          action: "ViewMyApplication",
          fromModule: "mentorDashboardHome",
        },
      });
    }
  };
  const [UpperdataMentor, setUpperdataMentor] = useState([
    [
      "",
      "",
      { role: "style" },
      {
        sourceColumn: 0,
        role: "annotation",
        type: "string",
        calc: "stringify",
      },
    ],
    ["", 0, "color: #e4c8f1", null],
    ["", 0, "color: #d1b2de", null],
    ["", 0, "color: #bdb1e3", null],
  ]);
  const Upperdata = [
    [
      "",
      "",
      { role: "style" },
      {
        sourceColumn: 0,
        role: "annotation",
        type: "string",
        calc: "stringify",
      },
    ],
    ["", 0, "color: #e4c8f1", null],
    ["", 0, "color: #d1b2de", null],
    ["", 0, "color: #bdb1e3", null],
    ["", 0, "color: #9e94c7", null],
  ];
  const imageUrl = "https://uat-nmp-api.startupindia.gov.in/v1/document/";
  // history.push({
  //   pathname:'/startup-profile',
  //   state: props.history.location.state,
  //   )}}

  //  const getFilterOutput=(output)=>{
  //  }
  const [isParentData, setIsParentData] = useState("");
  const [isModalShown, setIsModalShown] = useState(false);

  // useEffect(()=>{

  // },[isParentData])
  useEffect(() => {
    // axios({
    //   url: SEARCH_LIST_COUNTERS,
    //   method: "POST",
    //   data: {
    //     requestedBy: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //   },
    // })
    api
      .POST(SEARCH_LIST_COUNTERS, {
        requestedBy: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      })
      .then((res) => {
        setCounters(res.data?.data);
        // props.closeLoader()
      })
      .catch((err) => {});

    // setSession()

    // VIEW_COUNTER_SESSIONS
    // axios({
    //   url: VIEW_COUNTER_SESSIONS,
    //   method: "POST",
    //   data: {
    //     requestedBy: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //   },
    // })
    api
      .POST(VIEW_COUNTER_SESSIONS, {
        requestedBy: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      })
      .then((res) => {
        setSession(res.data?.data);
        // props.closeLoader()
      })
      .catch((err) => {});

    // axios({
    //   url: VIEW_COUNTER_HOURS,
    //   method: "POST",
    //   data: {
    //     requestedBy: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //   },
    // })
    api
      .POST(VIEW_COUNTER_HOURS, {
        requestedBy: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      })
      .then((res) => {
        setHours(res.data?.data);
        // props.closeLoader()
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    // html.style.overflow = "auto";
    // getAllData();
    const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));

    // axios({
    //   url: MENTORSHIPS_COUNTER,
    //   method: "post",
    //   data: {
    //     mentorId: value?.id,
    //   },
    // })
    api
      .POST(MENTORSHIPS_COUNTER, {
        requestedBy: value?.id,
      })
      .then((res) => {
        setCounterData(res.data?.data);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    try {
      let value = localStorage.getItem("SavedLoggedInData");
      let parsedData = JSON.parse(value);

      const params = { id: parsedData.dippNumber };
      api
        .POST(`${VIEW_STARTUP_APPLICATION_DATA}`, params)
        .then((response) => {
          const { data, status } = response || {};
          if (status === 200) {
            if (response.data.data) {
              if (response.data.data.applicationStatus === "DRAFT") {
                setSaveAsDraftStatus("DRAFT");
                setDraftResponse(response.data.data);
              } else {
                setSaveAsDraftStatus(response.data.data.applicationStatus);
                if (response.data.data.applicationStatus === "SUBMITTED") {
                  setDraftResponse(response.data.data);
                } else {
                  setDraftResponse("");
                }
              }
            }
          } else {
          }
        })
        .catch((e) => {});
    } catch (error) {}
  }, []);
  useEffect(() => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      state: "", // optional
      industry: "", // optional
      function: "", // optional
      stage: "", // optional
    };

    let sessionparams = {
      requestedBy: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    };
    getCountersList(params);
    getCountersSessions(sessionparams);
  }, []);

  const modifyGraphData = () => {
    let data = [
      [
        "",
        "",
        { role: "style" },
        {
          sourceColumn: 0,
          role: "style",
          type: "string",
          calc: "stringify",
        },
      ],
      ["", counters !== undefined ? counters.total : 0, "color: #9e94c7", null],
      [
        "",
        counters !== undefined ? counters.accepted : 0,
        "color: #bdb1e3",
        null,
      ],
      [
        "",
        counters !== undefined ? counters.rejected : 0,
        "color: #d1b2de",
        null,
      ],
    ];
    setUpperdataMentor(data);
  };

  const seriesLabelColors = [
    "#9e94c7",
    "#bdb1e3",
    "#d1b2de",
    "#d3a6e8",
    "#8072ab",
  ];

  const seriesLabels = [
    "Total Requested",
    "Total Accepted",
    "Total Declined",
    "",
    "",
    // "",
    // "",
  ];

  const seriesLabels2 = [
    "Till Date Scheduled",
    "Till Date Completed",
    "This Quarter Scheduled",
    "This Quarter Completed",
    "Upcoming",
    // "",
    // "",
  ];

  const seriesLabels3 = [
    "Till Date Scheduled",
    "Till Date Completed",
    "This Quarter Scheduled",
    "This Quarter Completed",
    "Upcoming",
    // "",
    // "",
  ];

  const options = {
    chart: {
      type: "bar",
      height: 300,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      function ({ value, seriesIndex, dataPointIndex, w }) {
        // if (dataPointIndex == 8) {
        //   return "#7E36AF";
        // } else {
        //   return "#D9534F";
        // }
        return seriesLabelColors[dataPointIndex];
      },
    ],
    grid: {
      show: true, // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: true, //or just here to disable only x axis grids
        },
      },
      yaxis: {
        lines: {
          show: false, //or just here to disable only y axis
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div class="arrow_box">' +
          "<span>" +
          // w.globals.labels[dataPointIndex] +
          seriesLabels[dataPointIndex] +
          ": " +
          (Math.round(series[seriesIndex][dataPointIndex] * 100) / 100).toFixed(
            2
          ) +
          "</span>" +
          "</div>"
        );
      },
    },

    xaxis: {
      categories: [
        // "Total Application",
        // "Total Approved",
        // "Total Pending",
        // "Total Rejected",
        // "Total Drafts",
        "",
        "",
        "",
        "",
        "",
        // "France",
        // "Japan",
        // "United States",
        // "China",
        // "Germany",
      ],
    },
  };

  const optionshours = {
    chart: {
      type: "bar",
      height: 300,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      function ({ value, seriesIndex, dataPointIndex, w }) {
        // if (dataPointIndex == 8) {
        //   return "#7E36AF";
        // } else {
        //   return "#D9534F";
        // }
        return seriesLabelColors[dataPointIndex];
      },
    ],
    grid: {
      show: true, // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: true, //or just here to disable only x axis grids
        },
      },
      yaxis: {
        lines: {
          show: false, //or just here to disable only y axis
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div class="arrow_box">' +
          "<span>" +
          // w.globals.labels[dataPointIndex] +
          seriesLabels2[dataPointIndex] +
          ": " +
          (Math.round(series[seriesIndex][dataPointIndex] * 100) / 100).toFixed(
            2
          ) +
          "</span>" +
          "</div>"
        );
      },
    },

    xaxis: {
      categories: [
        // "Total Application",
        // "Total Approved",
        // "Total Pending",
        // "Total Rejected",
        // "Total Drafts",
        "",
        "",
        "",
        "",
        "",
        // "France",
        // "Japan",
        // "United States",
        // "China",
        // "Germany",
      ],
    },
  };

  const optionsessions = {
    chart: {
      type: "bar",
      height: 300,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      function ({ value, seriesIndex, dataPointIndex, w }) {
        // if (dataPointIndex == 8) {
        //   return "#7E36AF";
        // } else {
        //   return "#D9534F";
        // }
        return seriesLabelColors[dataPointIndex];
      },
    ],
    grid: {
      show: true, // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: true, //or just here to disable only x axis grids
        },
      },
      yaxis: {
        lines: {
          show: false, //or just here to disable only y axis
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div class="arrow_box">' +
          "<span>" +
          // w.globals.labels[dataPointIndex] +
          seriesLabels3[dataPointIndex] +
          ": " +
          (Math.round(series[seriesIndex][dataPointIndex] * 100) / 100).toFixed(
            2
          ) +
          "</span>" +
          "</div>"
        );
      },
    },

    xaxis: {
      categories: [
        // "Total Application",
        // "Total Approved",
        // "Total Pending",
        // "Total Rejected",
        // "Total Drafts",
        "",
        "",
        "",
        "",
        "",
        // "France",
        // "Japan",
        // "United States",
        // "China",
        // "Germany",
      ],
    },
  };

  const seriesMentor = [
    {
      data: [
        counters ? counters.total : 0,
        counters ? counters.accepted : 0,
        counters ? counters.rejected : 0,
        0,
        0,
      ],
    },
  ];
  // session
  const seriesMentorHours = [
    {
      data: [
        hours ? hours.tillDateScheduledHours : 0,
        hours ? hours.tillDateCompletedHours : 0,
        hours ? hours.quarterScheduledHours : 0,
        hours ? hours.quarterCompletedHours : 0,
        0,
      ],
    },
  ];
  const seriesMentorSessions = [
    {
      data: [
        session ? session.tillDateScheduled : 0,
        session ? session.tillDateCompleted : 0,
        session ? session.quarterScheduled : 0,
        session ? session.quarterCompleted : 0,
        session ? session.upcoming : 0,
      ],
    },
  ];

  const [popup, setPopup] = useState(false);

  useEffect(() => {
    if (
      loggedIn?.applicationStatus === "SUBMITTED" &&
      engagementList !== "" &&
      engagementList !== null &&
      engagementList?.length > 0
    )
      // axios({
      //   url: "https://uat-nmp-api.startupindia.gov.in/v1/mentorship/checkUserActivity",
      //   method: "post",
      //   data: {
      //     id: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      //   },
      // })
      api
        .POST(
          "https://uat-nmp-api.startupindia.gov.in/v1/mentorship/checkUserActivity",
          {
            id: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
          }
        )
        .then((res) => {
          if (JSON.parse(localStorage.getItem("InactivityAlert")) === null) {
            localStorage.setItem("InactivityAlert", "true");
            if (PRODUCTION_MOVE_HIDDEN) {
              return;
            }
            if (res?.data?.data) {
              swal(
                "Mentorship Inactivity Alert",
                "Please update the details of your ongoing mentorship session. If there is no activity for 30 days, the mentorship session will be presumed complete",
                "info",
                { closeOnClickOutside: false }
              ).then(function () {});
            }
          } else {
          }
          // swal("", "Please update the details of your ongoing mentorship session. If there is no activity for 30 days, the mentorship session will be presumed complete", "info",title: "WARNING",
          // )
        })
        .catch((err) => {
          // console.log(err);
        });
  }, [engagementList]);
  useEffect(() => {
    // axios({
    //   url: MY_MENTORSHIP_LIST,
    //   method: "POST",
    //   data: {
    //     requestedBy: loggedIn?.id,
    //     status: "ACTIVE",
    //   },
    // })
    api
      .POST(MY_MENTORSHIP_LIST, {
        requestedBy: loggedIn?.id,
        status: "ACTIVE",
      })
      .then((res) => {
        // setEngagementList(res.data?.data);
        let data = res.data.data;
        if (data !== undefined && data !== null && data?.length > 0) {
          let obj;
          let arr = [];
          data.map((item, index) => {
            obj = {
              label: item?.mentorRequest.mentorName,
              value: item?.mentorRequest.mentorId,
              mentorshipId: item?.id,
            };
            arr.push(obj);
          });
          setEngagementList(arr);
        }
        // props.closeLoader();
      })
      .catch((err) => {
        // props.closeLoader();
      });
    cohortApplicationTable();
  }, []);
  const cohortApplicationTable = () => {
    let params = {
      cohortId: "",
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      state: null,
      industry: "",
      function: "",
      stage: "",
      searchField: "",
      searchKey: null,
      status: "APPROVED",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    getMentorCohortApplicationList(params);
  };
  useEffect(() => {
    if (
      getListData !== undefined &&
      getListData !== "" &&
      getListData !== null &&
      getListData?.length > 0
    ) {
      let arr = [];
      // arr.push({date:"2023-08-12",cohortId:"64c780962037ab524f9f1ee9"});
      // arr.push({date:"2023-08-09",cohortId:"64c780962037ab524f9f1ee9"});
      // arr.push({date:"2023-08-10",cohortId:"64c780962037ab524f9f1ee9"});
      // arr.push({date:"2023-08-11",cohortId:"64c780962037ab524f9f1ee9"});
      getListData.forEach((element) => {
        if(element?.cohortApplication?.nextSession !== null && element?.cohortApplication?.nextSession !== undefined && element?.cohortApplication?.nextSession !== "" )
        arr.push({
          date: moment(element?.cohortApplication?.nextSession).format("YYYY/MM/DD"),
          cohortId: element?.cohortId,
        });
      });
      let nearestDate;
      let nearestDate2;
      const dateToCheckFor = moment().format("YYYY/MM/DD");
      arr.forEach((element) => {
        // let diff = moment(element?.date).diff(moment(dateToCheckFor), "days");
        // if (diff > 0) {
          if (nearestDate) {
            if (moment(element?.date).diff(moment(nearestDate), "days") < 0) {
              nearestDate = element?.date;
              nearestDate2 = element;
            }
          } else {
            nearestDate = element?.date;
            nearestDate2 = element;
          }
        // }
      });
      if (
        nearestDate !== undefined &&
        nearestDate !== null &&
        nearestDate !== ""
      ) {
        setCohortRedirection(nearestDate2);
      }
    }
  }, [getListData]);
  const once = () => {
    let logged = localStorage.getItem("logged");

    if (logged) {
      localStorage.setItem("logged", "false");
      setMentorCounter(false);
    } else {
      localStorage.setItem("logged", "true");
      setMentorCounter(true);
    }
  };

  useEffect(() => {
    once();
  }, []);
  useEffect(() => {
    let params = {
      cohortId: "",
      organization_name: "",
      startupId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      // industry: filterIndustry ? filterIndustry : null,
      industry: "",
      // function: filterFunction ? filterFunction : null,
      function: "",
      // stage: filterStage ? filterStage : null,
      stage: "",
      requestStatus: "",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 9,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: "",
      searchKey: "",
      fromStartup: true,
    };

    getCohortStartupList(params);
  }, []);
  return (
    <div className="mentor-dashboard">
      {mentorCounter ? (
        <Modal
          modalOpen={modalOpen2}
          setModalOpen={setModalOpen2}
          // modalData={modalData}
        />
      ) : (
        ""
      )}
      {/* <Modal
        modalOpen={modalOpen2}
        setModalOpen={setModalOpen2}
        // modalData={modalData}
      /> */}
      <CustomizedDialogs
        open={popup}
        setOpen={() => setPopup(true)}
        setClose={() => setPopup(false)}
      />
      <div className="col-md-12 col-sm-12 col-lg-12 wow fadeInDown text-center abovehomepagesecondhead">
        <h3 className="mb-0 homepageSecondHeader">
          <a title="" tabindex="0">
            MAARG Portal by Startup India
          </a>
        </h3>

        <h3 className="dashboard-sub-heading homepageFirstHeader">
          MY STARTUP DASHBOARD
        </h3>
      </div>
      <div className="container">
        <div className="applicationBox sm-p-0 sm-m-0 lg-p-0 lg-m-0 w-100 h-100">
          <div className="container lg-p-0 lg-m-0 sm-p-0 sm-m-0">
            <div className="mentor-content mt-20 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
              <div className="row lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                <div
                  className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0  d-flex justify-content-center"
                  style={{ paddingLeft: "2rem" }}
                >
                  <img
                    style={{
                      height: "7em",
                      width: "auto",
                      maxHeight: "170px",
                      objectFit: "contain",
                      // imageUrl+
                    }}
                    src={
                      draftResponse && draftResponse.upload_logo === null
                        ? hashImage
                        : draftResponse && draftResponse.upload_logo
                    }
                  />
                </div>
                <div className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                  <div className="mentor-info2 lg-p-0 lg-m-0 sm-p-0 sm-m-0 startUpAlignment">
                    <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      STARTUP NAME
                    </h5>
                    <h4 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      {draftResponse && draftResponse.entity_name}
                    </h4>
                  </div>
                </div>
                <div className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                  <div className="mentor-info2 lg-p-0 lg-m-0 sm-p-0 sm-m-0 startUpAlignment">
                    <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      DPIIT Number
                    </h5>
                    <div className="newuserTooltip">
                      <div>
                        <h4
                          className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            ViewApplication(
                              draftResponse && draftResponse.dpiit_no
                            )
                          }
                        >
                          {draftResponse && draftResponse.dpiit_no}
                        </h4>
                        <span className="tooltiptext dpiitnumber tooltip-bottom">
                          View Application
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0  d-flex justify-content-center"
                  style={{ paddingLeft: "2rem" }}
                >
                  <img
                    style={{
                      height: "7em",
                      width: "auto",
                      maxHeight: "170px",
                    }} //imageUrl+
                    src={
                      draftResponse && draftResponse.upload_profile === null
                        ? hashImage
                        : draftResponse && draftResponse.upload_profile
                    }
                  />
                </div>
                <div className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                  <div className="mentor-info2 lg-p-0 lg-m-0 sm-p-0 sm-m-0 startUpAlignment">
                    <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      CONTACT NAME
                    </h5>
                    <h4 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      {draftResponse && draftResponse.applicant_name}
                    </h4>
                  </div>
                </div>
                <div className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                  <div className="mentor-info2 lg-p-0 lg-m-0 sm-p-0 sm-m-0 startUpAlignment">
                    <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      {saveAsDraftStatus === "DRAFT" ? "STATUS" : "CITY"}
                    </h5>
                    <h4 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      {/* {alert(saveAsDraftStatus)} */}
                      {saveAsDraftStatus === "DRAFT"
                        ? "DRAFT"
                        : draftResponse && draftResponse.city}
                    </h4>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-2 newuserTooltip"
                // onClick={redirectProfile}
                // onClick={() => history.push({
                //   pathname:'/startup-profile',
                //   state: props.history.location.state,
                //   )}}
              >
                <button
                  className="profileButton2 col-lg-2 top-btn"
                  onClick={() =>
                    redirectProfile(draftResponse && draftResponse.dpiit_no)
                  }
                >
                  VIEW PROFILE
                </button>
                <span className="tooltiptext vewprofile tooltip-bottom">
                  View Startup Profile
                </span>
              </div>
              <div className="row lg-p-0 lg-m-0 sm-p-0 sm-m-0 d-flex startupDashAlign">
                <div className="col-md-9 lg-p-0 lg-m-0 sm-p-0 sm-m-0 editprofabovebtn">
                  <div
                    className="mentor-purple-btn-view-dashboard3 unapprovedcard top-btn lg-p-0 lg-m-0 newuserTooltip "
                    onClick={() => EditApplication(saveAsDraftStatus)}
                    style={{ cursor: "pointer" }}
                  >
                    <a className="blue-link2">
                      {saveAsDraftStatus === "DRAFT"
                        ? "COMPLETE APPLICATION"
                        : "EDIT PROFILE"}
                    </a>
                    {saveAsDraftStatus === "DRAFT" ? (
                      <span className="tooltiptext completeProfile tooltip-bottom">
                        Complete Application
                      </span>
                    ) : (
                      <span className="tooltiptext editProfile tooltip-bottom">
                        Edit Startup Profile
                      </span>
                    )}
                  </div>
                  {/* <div
            className="dashboard-bottom-btn22 top-btn newuserTooltip"
            onClick={() => {
              localStorage.setItem(
                "sessionRecording",
                "sessionRecording"
              );
              window.location.reload();  
            }}
            style={{position:"relative",left:"32.95rem",fontSize:"16px",top:"-3rem",height:"52px !important"}}
          >
            <p
              style={{ cursor: "pointer",fontSize:"16px",left:"-1.75rem",top:"-0.25rem" }}
              className="text-white3 createcohortsessionbtnpara"
            >
              SESSION RECORDINGS
            </p>
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "130px", top: "60px", width: "220px" }}
            >
              Click to view Session Recordings
            </span>
          </div> */}
                </div>
                {/* {isModalShown&&(
                  <div onClick={handleShow}>
                <ModalFilters  sendToParent={setIsParentData} modalVisibility={isModalShown} setModalVisibility={setIsModalShown}/>
                </div>
                )
                } */}
                {/* { !isModalShown &&(
                <div className="col-2 startupBtn " 
                // onClick={handleShow}
                >
                    <img className="top-btn" src={startupBtn} />
                    <ModalFilters  sendToParent={setIsParentData} modalVisibility={isModalShown} setModalVisibility={setIsModalShown}/>
                    </div>
                  )
                }  */}
                {saveAsDraftStatus === "DRAFT" &&
                saveAsDraftStatus !== undefined ? (
                  ""
                ) : (
                  <>
                    <div
                      className="startupBtn top-btn newuserTooltip"
                      onClick={handleShow}
                    >
                      <img src={startupBtn} />
                      <div className="topBtnText topbtninnertext">
                        CREATE A NEW
                        <br />
                        MENTORSHIP REQUIREMENT
                      </div>
                      <span className="tooltiptext reuuirementbtn  tooltip-bottom">
                        Create A New Mentorship Requirement
                      </span>
                    </div>
                  </>
                )}
                {isModalShown && (
                  <ModalFilters
                    sendToParent={setIsParentData}
                    modalVisibility={isModalShown}
                    setModalVisibility={setIsModalShown}
                    fromModule="startUpDashboard"
                    setRedirect={props.setSelectedMenu}
                  />
                )}
              </div>
              <div className="container userGuideContainer">
              <div className="row g-0">
                <div className="col-12">
                <a target="_blank" href={userGuide}>

                    <div
                      className="startupBtn top-btn newuserTooltip startupUserGuide"
                      // onClick={handleShow}
                    >
                      <img src={startupBtn} className="startupUserGuideImg" />
                      <div className="topBtnText4 topbtninnertext">
                      USER GUIDE 
                        <br />
                        FOR STARTUPS
                      </div>
                      <span className="tooltiptext reuuirementbtn  tooltip-bottom">
                      Click to Open Guide Book for Startups
                      </span>
                    </div>
                  </a>
                </div>
              
              </div>
              </div>
            
            </div>
          </div>
        </div>
        {saveAsDraftStatus === "DRAFT" && saveAsDraftStatus !== undefined ? (
          ""
        ) : (
          <>
            <ul className="startupdashboard-cards w-100 h-100 m-0 p-0">
              <li className="dashboard-cards_item2">
                <div style={{ width: "100%" }}>
                  <div className="dashboard-card-mentor2 startupgraphDash">
                    <div
                      className="dashboard-card_image"
                      style={{ marginTop: "10px", marginBottom: "7px" }}
                    >
                      <img className="startUpBoxImg" src={startupIcon} />
                    </div>
                    <div
                      className="dashboard-card_content md-p-0 sm-p-0 lg-p-0"
                      style={{ marginTop: "14px" }}
                    >
                      <h3
                        className="dashboard-card-heading startUpBoxTex homepageFourthDescription"
                        style={{ bottom: "2rem", position: "relative" }}
                      >
                        MENTORSHIP REQUESTS
                      </h3>
                      <div style={{ marginBottom: "13%", marginTop: "0px" }}>
                        <Chart
                          options={options}
                          series={seriesMentor}
                          type="bar"
                          height={200}
                        />
                      </div>
                      <div className="inner-dashboard-view md-p-0 sm-p-0 lg-p-0 startUpBoxText2">
                        <div className="rowC">
                          <div className="square1"></div>
                          <p className="homepageFifthDescription">
                            Total Requested :{" "}
                            <span>
                              {counters !== undefined ? counters.total : 0}
                            </span>
                          </p>
                        </div>
                        <div className="rowC">
                          <div className="square2"></div>
                          <p className="homepageFifthDescription">
                            Total Accepted :{" "}
                            <span>
                              {counters !== undefined ? counters.accepted : 0}
                            </span>
                          </p>
                        </div>
                        <div className="rowC">
                          <div className="square4"></div>
                          <p className="homepageFifthDescription">
                            Total Declined :{" "}
                            <span>
                              {counters !== undefined ? counters.rejected : 0}
                            </span>
                          </p>
                        </div>
                      </div>
                      <div
                        className="dashboard-purple-btn top-btn mt-2 newuserTooltip"
                        style={{
                          width: "100%",
                          position: "relative",
                          top: "1rem",
                          // paddingLeft:"79px",
                        }}
                        onClick={() => {
                          history.push({
                            path: "/startup-dashboard",
                            state: "startUpDash",
                          });
                          props.setSelectedMenu("myRequests");
                        }}
                      >
                        <span
                          className="blue-link-dashboard2"
                          // props.setSelectedMenu("")
                          style={{
                            paddingRight: "0px",
                            cursor: "pointer",
                            fontWeight: "600",
                          }}
                        >
                          {" "}
                          Mentor Requests
                        </span>
                        <span className="tooltiptext mymentor tooltip-bottom">
                          View Mentor Requests
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="dashboard-cards_item2">
                <div style={{ width: "100%" }}>
                  <div className="dashboard-card-startup startupgraphDash">
                    <div
                      className="dashboard-card_image"
                      style={{ marginTop: "10px", marginBottom: "7px" }}
                    >
                      <img src={twoGears} className="startUpDashGear" />
                    </div>
                    <div className="dashboard-card_content">
                      <h3 className="dashboard-card-heading22 homepageFourthDescription">
                        MENTORSHIP HOURS
                      </h3>
                      {/* <div className="startUpChart2">
                        <HorizontalBarChart chartData={Upperdata} />
                      </div> */}
                      <div className="startUpChart2 newChartPositionFix2">
                        {/* <HorizontalBarChart chartData={Upperdata} /> */}
                        <Chart
                          options={optionshours}
                          series={seriesMentorHours}
                          type="bar"
                          height={200}
                          // width={500} height={320}
                        />
                      </div>
                      <div className="inner-dashboard-view startUpChart2">
                        <div className="rowC">
                          <div className="square1"></div>
                          <p className="homepageFifthDescription">
                            Till Date Scheduled :{" "}
                            <span>
                              {" "}
                              {hours !== undefined
                                ? parseFloat(
                                    hours.tillDateScheduledHours
                                  ).toFixed(2)
                                : 0}
                            </span>
                          </p>
                        </div>
                        <div className="rowC">
                          <div className="square2"></div>
                          <p className="homepageFifthDescription">
                            Till Date Completed :{" "}
                            <span>
                              {hours !== undefined
                                ? parseFloat(
                                    hours.tillDateCompletedHours
                                  ).toFixed(2)
                                : 0}
                            </span>
                          </p>
                        </div>
                        <div className="rowC">
                          <div className="square3"></div>
                          <p className="homepageFifthDescription">
                            This Quarter Scheduled :{" "}
                            <span>
                              {hours !== undefined
                                ? parseFloat(
                                    hours.quarterScheduledHours
                                  ).toFixed(2)
                                : 0}
                            </span>
                          </p>
                        </div>
                        <div className="rowC">
                          <div className="square4"></div>
                          <p className="homepageFifthDescription">
                            This Quarter Completed :{" "}
                            <span>
                              {hours !== undefined
                                ? parseFloat(
                                    hours.quarterCompletedHours
                                  ).toFixed(2)
                                : 0}
                            </span>
                          </p>
                        </div>
                        <div
                          className="rowC"
                          style={{ paddingBottom: "6.5rem" }}
                        >
                          {/* <div className="square5"></div> */}
                          {/* <p>
                            Upcoming :{" "}
                            <span>
                              {hours !== undefined
                                ? parseFloat(hours.upcomingHours).toFixed(2)
                                : 0}
                            </span>
                          </p> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="dashboard-cards_item2">
                <div style={{ width: "100%" }}>
                  <div className="dashboard-card-mentor2 startupgraphDash">
                    <div
                      className="dashboard-card_image"
                      style={{ marginTop: "10px", marginBottom: "7px" }}
                    >
                      <img className="startUpBoxImg" src={cohortIcon} />
                    </div>
                    <div
                      className="dashboard-card_content md-p-0 sm-p-0 lg-p-0"
                      style={{ marginTop: "14px" }}
                    >
                      <h3
                        className="dashboard-card-heading startUpBoxText homepageFourthDescription"
                        style={{ bottom: "2rem" }}
                      >
                        MENTORSHIP SESSIONS
                      </h3>
                      <div style={{ marginBottom: "13%", marginTop: "0px" }}>
                        <Chart
                          options={optionsessions}
                          series={seriesMentorSessions}
                          type="bar"
                          height={200}
                        />
                      </div>
                      <div className="inner-dashboard-view md-p-0 sm-p-0 lg-p-0 startUpBoxText2">
                        <div className="rowC">
                          <div className="square1"></div>
                          <p className="homepageFifthDescription">
                            Till Date Scheduled :{" "}
                            <span>
                              {session !== undefined
                                ? session.tillDateScheduled
                                : 0}{" "}
                            </span>
                          </p>
                        </div>
                        <div className="rowC">
                          <div className="square2"></div>
                          <p className="homepageFifthDescription">
                            Till Date Completed :{" "}
                            <span>
                              {session !== undefined
                                ? session.tillDateCompleted
                                : 0}
                            </span>
                          </p>
                        </div>
                        <div className="rowC">
                          <div className="square3"></div>
                          <p className="homepageFifthDescription">
                            This Quarter Scheduled :{" "}
                            <span>
                              {session !== undefined
                                ? session.quarterScheduled
                                : 0}
                            </span>
                          </p>
                        </div>
                        <div className="rowC">
                          <div className="square4"></div>
                          <p className="homepageFifthDescription">
                            This Quarter Completed :{" "}
                            <span>
                              {session !== undefined
                                ? session.quarterCompleted
                                : 0}
                            </span>
                          </p>
                        </div>
                        <div className="rowC">
                          <div className="square5"></div>
                          <p className="homepageFifthDescription">
                            Upcoming :{" "}
                            <span>
                              {session !== undefined ? session.upcoming : 0}
                            </span>
                          </p>
                        </div>
                      </div>

                      <div
                        className="dashboard-purple-btn top-btn tooltipicon mt-1 mb-4"
                        style={{
                          width: "100%",
                          cursor: "default",
                          position: "relative",
                          top: "-1.8rem",
                          paddingTop: "14px",
                        }}
                        onClick={() => {
                          if (PRODUCTION_MOVE_HIDDEN) {
                            props.setOpen();
                            return;
                          }
                          if (
                            session?.sessionSchedule?.sessionStart !== null &&
                            session?.sessionSchedule?.sessionStart !== undefined
                          )
                            window.open(
                              `/mentor-dashboard/mentorships/engagement-summary/${session?.sessionSchedule?.mentorshipId}`,
                              "_blank"
                            );
                          // setModalOpen(true);
                        }}
                      >
                        <div className="newuserTooltip">
                          <div
                            className="blue-link-dashboard2 nextsessonbtn"
                            style={{
                              paddingRight: "0px",
                              cursor: "pointer",
                              fontWeight: "600",
                            }}
                          >
                            {" "}
                            {session?.sessionSchedule?.sessionStart === null ||
                            session?.sessionSchedule?.sessionStart ===
                              undefined ? (
                              <span
                                style={{
                                  position: "relative",
                                }}
                              >
                                Next Session : -
                              </span>
                            ) : (
                              <>
                                <span
                                  style={{
                                    position: "relative",
                                    bottom: "0.6rem",
                                  }}
                                >
                                  Next Session :
                                </span>
                                <br />
                                <span
                                  style={{
                                    position: "relative",
                                    bottom: "1.3rem",
                                  }}
                                >
                                  {session?.sessionSchedule?.sessionStart !==
                                    undefined &&
                                  session?.sessionSchedule?.sessionStart !==
                                    null
                                    ? moment(
                                        session?.sessionSchedule?.sessionStart
                                      ).format("DD/MM/YYYY hh:mm A")
                                    : "--"}
                                </span>
                              </>
                            )}
                            <span
                              className="tooltiptext  tooltip-bottom"
                              style={{
                                fontFamily: "Montserrat",
                                width: "150px",
                                padding: "0px 12px",
                                left: "25px",
                                top: "48px",
                              }}
                            >
                              View Session Details
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* <div
                        className="dashboard-purple-btn top-btn tooltipicon mt-1 mb-4"
                        style={{
                          width: "100%",
                          cursor: "default",
                          position: "relative",
                          top: "-1.8rem",
                        }}
                        onClick={() => {
                          window.open(
                            `/mentor-dashboard/mentorships/engagement-summary/${session?.sessionSchedule?.mentorshipId}`,
                            "_blank"
                          );
                          // setModalOpen(true);
                        }}
                      >
                        <div className="newuserTooltip">
                          <a
                            className="blue-link-dashboard2"
                            style={{
                              paddingRight: "0px",
                              cursor: "default",
                              fontWeight: "600",
                            }}
                          >
                            {" "}
                            <span style={{
                              position:"relative",
                              bottom:"0.6rem"
                            }}>
                            Next Session :
                            </span>
                            <br/>
                            <span style={{
                              position:"relative",
                              bottom:"1.3rem"
                            }}>
                            {session?.sessionSchedule?.sessionStart !==
                              undefined &&
                            session?.sessionSchedule?.sessionStart !== null
                              ? moment(session?.sessionSchedule?.sessionStart).format(
                                  "DD/MM/YYYY hh:mm A"
                                )
                              : "00"}
                              </span>
                            <span className="tooltiptext mymentor tooltip-bottom">
                            View Next Session
                            </span>
                          </a>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </li>
              {/* <li className="dashboard-cards_item2">
                <div style={{ width: "100%" }}>
                  <div
                    className="dashboard-card-startup"
                    style={{ minHeight: "50%", height: "620px" }}
                  >
                    <div
                      className="dashboard-card_image"
                      style={{ marginTop: "10px", marginBottom: "7px" }}
                    >
                      <img src={cohortIcon} className="cohortMeeting" />
                    </div>
                    <div className="dashboard-card_content">
                      <h3 className="dashboard-card-heading3">
                        MENTORSHIP SESSIONS
                      </h3>
                      <div
                        className="startUpChart2 newChartPositionFix"
                        style={{ marginTop: "26px" }}
                      >
                        <Chart
                          options={optionsessions}
                          series={seriesMentorSessions}
                          type="bar"
                          height={200}
                        />
                      </div>
                      <div className="inner-dashboard-view startUpChart9">
                        <div className="rowC">
                          <div className="square1"></div>
                          <p>
                            Till Date Scheduled :{" "}
                            <span>
                              {session !== undefined
                                ? session.tillDateScheduled
                                : 0}
                            </span>
                          </p>
                        </div>
                        <div className="rowC">
                          <div className="square2"></div>
                          <p>
                            Till Date Completed :{" "}
                            <span>
                              {session !== undefined
                                ? session.tillDateCompleted
                                : 0}
                            </span>
                          </p>
                        </div>
                        <div className="rowC">
                          <div className="square3"></div>
                          <p>
                            This Quarter Schedule :{" "}
                            <span>
                              {session !== undefined
                                ? session.quarterScheduled
                                : 0}
                            </span>
                          </p>
                        </div>
                        <div className="rowC">
                          <div className="square4"></div>
                          <p>
                            This Quarter Completed :{" "}
                            <span>
                              {session !== undefined
                                ? session.quarterCompleted
                                : 0}
                            </span>
                          </p>
                        </div>
                        <div className="rowC">
                          <div className="square5"></div>
                          <p>
                            Upcoming :{" "}
                            <span>
                              {session !== undefined ? session.upcoming : 0}
                            </span>
                          </p>
                        </div>
                      </div>
                      <div
                        className="dashboard-purple-btn top-btn tooltipicon mt-1 mb-4"
                        style={{
                          width: "100%",
                          cursor: "default",
                          position: "relative",
                          top: "-2.8rem",
                        }}
                      >
                        <div className="tooltipicon">
                          <a
                            className="blue-link-dashboard2"
                            style={{
                              paddingRight: "0px",
                              cursor: "default",
                              fontWeight: "600",
                            }}
                          >
                            {" "}
                            Next Session : 00
                            <span className="tooltiptext5">
                              Please stay tuned, this function will be enabled
                              shortly after the launch of Startup onboarding
                              process.
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li> */}
            </ul>

            {PRODUCTION_MOVE_HIDDEN ? (
              <div className="w-100 pt-50 pb-10 position-relative text-center">
                <div className="container" style={{ backgroundColor: "#fff" }}>
                  <div className="row">
                    <div className="sec-title text-center w-100 position-relative">
                      <h2 className="mb-0 progressreport-bar">
                        PROGRESS IN LAST QUARTER{" "}
                      </h2>
                    </div>
                    <div className="col-md-12 col-sm-12 col-lg-12 wow slideInDown d-flex justify-content-center fiveLineImg">
                      <img className="counter-line" src={fiveLine} />
                    </div>
                  </div>

                  <div className="row circleButtonRow">
                    <div className="d-flex justify-content-center circleButtonBox">
                      <div className="col-md-4 col-sm-6 col-lg-2 wow slideInRight ">
                        <div className="button-ic">
                          <div className="fact-box w-100 h-100">
                            <h5 className="mb-0 impactcirclefont2 justify-content-center">
                              {progressReport !== null &&
                              progressReport?.stage !== undefined &&
                              progressReport?.stage !== ""
                                ? progressReport?.stage
                                : "NA"}
                              {/* {reportData && reportData !== "" &&
                            reportData?.stage !== undefined &&
                            reportData?.stage !== ""
                              ? reportData?.stage
                              :  localStorage.getItem("SavedLoggedInData")?JSON.parse(localStorage.getItem("SavedLoggedInData")).progressReport && 
                              JSON.parse(localStorage.getItem("SavedLoggedInData")).progressReport.stage:"NA"} */}
                            </h5>
                          </div>
                        </div>
                        <div className="circleBottomText">
                          CHANGE IN <br />
                          STATE
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-6 col-lg-2 wow slideInRight ">
                        <div className="button-ic">
                          <div className="fact-box w-100 h-100">
                            <h5 className="mb-0 impactcirclefont2 d-flex justify-content-center">
                              {progressReport !== null &&
                              progressReport?.jobsCreated !== undefined &&
                              progressReport?.jobsCreated !== ""
                                ? progressReport?.jobsCreated
                                : "NA"}
                              {/* {reportData && reportData !== "" &&
                            reportData?.jobsCreated !== undefined &&
                            reportData?.jobsCreated !== ""
                              ? reportData?.jobsCreated
                              :  localStorage.getItem("SavedLoggedInData")?JSON.parse(localStorage.getItem("SavedLoggedInData")).progressReport && 
                              JSON.parse(localStorage.getItem("SavedLoggedInData")).progressReport.jobsCreated:"00"} */}
                            </h5>
                          </div>
                        </div>
                        <div className="circleBottomText">
                          NEW JOBS <br />
                          CREATED
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-6 col-lg-2 wow slideInRight ">
                        <div className="button-ic">
                          <div className="fact-box w-100 h-100">
                            <h5 className="mb-0 impactcirclefont2 justify-content-center">
                              {progressReport !== null &&
                              progressReport?.revenueGenerated !== undefined &&
                              progressReport?.revenueGenerated !== ""
                                ? progressReport?.revenueGenerated
                                : "NA"}
                              {/* {reportData && reportData !== "" &&
                            reportData?.revenueGenerated !== undefined &&
                            reportData?.revenueGenerated !== ""
                              ? reportData?.revenueGenerated
                              :  localStorage.getItem("SavedLoggedInData")?JSON.parse(localStorage.getItem("SavedLoggedInData")).progressReport && 
                              JSON.parse(localStorage.getItem("SavedLoggedInData")).progressReport.revenueGenerated:"00"} */}
                            </h5>
                          </div>
                        </div>
                        <div className="circleBottomText">
                          REVENUE <br />
                          GENERATED
                          <br />
                          (INR)
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-6 col-lg-2 wow slideInRight ">
                        <div className="button-ic">
                          <div className="fact-box w-100 h-100">
                            <h5 className="mb-0 impactcirclefont2 d-flex justify-content-center">
                              {progressReport !== null &&
                              progressReport?.investmentRaised !== undefined &&
                              progressReport?.investmentRaised !== ""
                                ? progressReport?.investmentRaised
                                : "NA"}
                              {/* {reportData && reportData !== "" &&
                            reportData?.investmentRaised !== undefined &&
                            reportData?.investmentRaised !== ""
                              ? reportData?.investmentRaised
                              :  localStorage.getItem("SavedLoggedInData")?JSON.parse(localStorage.getItem("SavedLoggedInData")).progressReport && 
                              JSON.parse(localStorage.getItem("SavedLoggedInData")).progressReport.investmentRaised:"00"} */}
                            </h5>
                          </div>
                        </div>
                        <div className="circleBottomText">
                          NEW INVESTMENT <br />
                          RAISED
                          <br />
                          (INR)
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-6 col-lg-2 wow slideInRight ">
                        <div className="button-ic">
                          <div className="fact-box w-100 h-100">
                            <h5 className="mb-0 impactcirclefont2 justify-content-center">
                              {progressReport !== null &&
                              progressReport?.awards !== undefined &&
                              progressReport?.awards !== ""
                                ? progressReport?.awards
                                : "NA"}
                              {/* {reportData && reportData !== "" &&
                            reportData?.awards !== undefined &&
                            reportData?.awards !== ""
                              ? reportData?.awards
                              : localStorage.getItem("SavedLoggedInData")?JSON.parse(localStorage.getItem("SavedLoggedInData")).progressReport && 
                              JSON.parse(localStorage.getItem("SavedLoggedInData")).progressReport.awards:"NONE"} */}
                            </h5>
                          </div>
                        </div>
                        <div className="circleBottomText">
                          AWARDS AND <br />
                          RECOGNITION
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {PRODUCTION_MOVE_HIDDEN ? (
              <div className="container-fluid upload-progress">
                <div className="row">
                  <div className="col-4 sideImage" style={{ width: "15%" }}>
                    <img src={graphImage} />
                  </div>
                  <div
                    className="mentor-purple-btn-view-dashboard4 unapprovedcard top-btn col-4 newuserTooltip"
                    style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                    onClick={() => {
                      if (PRODUCTION_MOVE_HIDDEN) {
                        props.setOpen();
                        return;
                      }
                      setModalOpen(true);
                    }}
                  >
                    {/* <div onClick={() => {
                            setModalOpen(true)}}>
                    <a className="blue-link3">UPLOAD PROGRESS REPORT</a>

                  </div> */}
                    <div>
                      <a className="blue-link3 uploadprogbtn">
                        UPLOAD PROGRESS REPORT
                      </a>
                      <span className="tooltiptext-progress tooltip-bottom">
                        Please Click to Update Your Progress Report
                      </span>
                      {/* <span className="tooltiptext6">
                      Please stay tuned, this function will be enabled shortly
                      after the launch of Startup onboarding process.
                    </span> */}
                    </div>
                  </div>
                  <div className="col-4 threeGearsImage sideImage">
                    <img src={threeGears} />
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            <div className="bottomBoxHeight">
              <div
                className="container mt-2 startupButtonrow5"
                style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}
              >
                <div className="row">
                  <div
                    className="col-md-4 col-sm-9 col-lg-4 abovebenefitssec1 top-btn newuserTooltip "
                    style={{ cursor: "pointer" }}
                  >
                    <div
                      className="benefits-sec2"
                      onClick={() => {
                        if (PRODUCTION_MOVE_HIDDEN) {
                          props.setOpen();
                          return;
                        }
                        props.setStartUpIdList(
                          JSON.parse(localStorage.getItem("SavedLoggedInData"))
                            .id
                        );
                        window.open(
                          `/startup-dashboard/mentorships/${
                            JSON.parse(
                              localStorage.getItem("SavedLoggedInData")
                            ).id
                          }`,
                          "_blank"
                        );
                        // history.push("/startup-dashboard");
                        // props.setSelectedMenu("mentorships");
                      }}
                    >
                      <a className="benefits-heading benheading">
                        {/* MY MENTORSHIPS : {counters ? counters.accepted : 0} */}
                        MY MENTORSHIPS : {counterData && counterData.active}
                      </a>
                      <span className="tooltiptext mymentorships2  tooltip-bottom">
                        View Mentorships
                      </span>
                    </div>
                  </div>
                  <div
                    className="col-md-4 col-sm-6 col-lg-4 abovebenefitssec2 top-btn newuserTooltip "
                    style={{ cursor: "pointer" }}
                  >
                    <div
                      className="benefits-sec2"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (PRODUCTION_MOVE_HIDDEN) {
                          props.setOpen();
                          return;
                        }
                        props.setSelectedMenu("mentorMessages");
                        history.push("/startup-dashboard");
                      }}
                    >
                      <a className="benefits-heading benheading">
                        NEW MESSAGES :{" "}
                        {getNewMessagesData && getNewMessagesData?.unread}
                      </a>
                      <span className="tooltiptext mymentorships2  tooltip-bottom">
                        View New Messages
                      </span>
                    </div>
                  </div>
                  <div
                    className="col-md-4 col-sm-6 col-lg-4 abovebenefitssec3 top-btn"
                    style={{ cursor: "pointer" }}
                  >
                    <div
                      className="benefits-sec2 top-btn newuserTooltip"
                      onClick={
                        () => {
                          if (
                            cohortRedirection !== undefined &&
                            cohortRedirection !== "" &&
                            cohortRedirection?.length !== 0 &&
                            cohortRedirection !== null
                          ) {
                            window.open(
                              `/cohort-programs/cohortView/${cohortRedirection?.cohortId}`,
                              "_blank"
                            );
                            localStorage.setItem("cohortWindow", "resources");
                          }
                        }
                        // history.push(`/cohort-programs/all/${item?.cohortID}`)
                      }
                    >
                      <a className="benefits-heading benheading">
                        NEXT PROGRAM :{" "}
                      
                        {cohortRedirection !== undefined &&
                        cohortRedirection !== "" &&
                        cohortRedirection?.length !== 0 &&
                        cohortRedirection !== null
                          ? moment(cohortRedirection?.date).format("DD/MM/YYYY")
                          : "00"}
                      </a>
                      <span className="tooltiptext mentormymentorship  tooltip-bottom">
                        {cohortRedirection !== undefined &&
                        cohortRedirection !== "" &&
                        cohortRedirection?.length !== 0 &&
                        cohortRedirection !== null
                          ? "Click to open program"
                          : "No upcoming program"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <UploadProgressReportModal
              modalVisibility={modalOpen}
              setModalVisibility={setModalOpen}
              parentData={setReportData}
            />
          </>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getCounter: state.AdminMentorReducer.getCountersList.data,
    getSession: state.AdminMentorReducer.getCountersSessions.data,
    getNewMessagesData: state.StartUpReducer.getNewMessages.data,
    getCohortTableData: state.MentorReducer.getCohortMentorList.data,
    getListData: state.StartUpReducer.getCohortForStartupList.data,
  };
};

const setOpen = () => (dispatch) => {
  dispatch({ type: types.SET_OPEN });
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
  getCountersList,
  setOpen,
  getCountersSessions,
  getNewMessagesDash,
  getMentorCohortApplicationList,
  getCohortStartupList,
})(withRouter(StartupDashboard));
